import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CrudSection from "./CrudSection";
import {
    listRegionApi, createRegionApi, updateRegionApi, deleteRegionApi,
    listProvinceApi, createProvinceApi, updateProvinceApi, deleteProvinceApi,
    listMunicipalityApi, createMunicipalityApi, updateMunicipalityApi, deleteMunicipalityApi,
    listComarcaApi, createComarcaApi, updateComarcaApi, deleteComarcaApi,
    listCountryApi, createCountryApi, updateCountryApi, deleteCountryApi
} from "../../../../services/Admin/geografia";
import useAuth from "../../../../hooks/useAuth";
import Card from "../../../../components/Admin/Card";

export default function GestionGeografia() {
    const { auth } = useAuth();

    // Regions
    const [regions, setRegions] = useState([]);
    const [loadingRegions, setLoadingRegions] = useState(false);

    // Provinces
    const [provinces, setProvinces] = useState([]);
    const [loadingProvinces, setLoadingProvinces] = useState(false);

    // Municipalities
    const [municipalities, setMunicipalities] = useState([]);
    const [loadingMunicipalities, setLoadingMunicipalities] = useState(false);

    // Comarcas
    const [comarcas, setComarcas] = useState([]);
    const [loadingComarcas, setLoadingComarcas] = useState(false);

    // Countries
    const [countries, setCountries] = useState([]);
    const [loadingCountries, setLoadingCountries] = useState(false);

    const [selectedType, setSelectedType] = useState("paises");

    useEffect(() => {
        fetchRegions();
        fetchProvinces();
        fetchMunicipalities();
        fetchComarcas();
        fetchCountries();
    }, []);

    const handleSelectChange = (event) => {
        setSelectedType(event.target.value);
    };

    // Regions CRUD
    const fetchRegions = () => {
        setLoadingRegions(true);
        listRegionApi().then(resp => {
            setRegions(resp.data.data || []);
        }).finally(() => setLoadingRegions(false));
    };
    const addRegion = (data, cb) => {
        createRegionApi(data).then(fetchRegions).finally(cb);
    };
    const editRegion = (data, cb) => {
        updateRegionApi(data.id, data).then(fetchRegions).finally(cb);
    };
    const deleteRegion = (id) => {
        deleteRegionApi(id).then(fetchRegions);
    };

    // Provinces CRUD
    const fetchProvinces = () => {
        setLoadingProvinces(true);
        listProvinceApi().then(resp => {
            setProvinces(resp.data.data || []);
        }).finally(() => setLoadingProvinces(false));
    };
    const addProvince = (data, cb) => {
        createProvinceApi(data).then(fetchProvinces).finally(cb);
    };
    const editProvince = (data, cb) => {
        updateProvinceApi(data.id, data).then(fetchProvinces).finally(cb);
    };
    const deleteProvince = (id) => {
        deleteProvinceApi(id).then(fetchProvinces);
    };

    // Municipalities CRUD
    const fetchMunicipalities = () => {
        setLoadingMunicipalities(true);
        listMunicipalityApi().then(resp => {
            setMunicipalities(resp.data.data || []);
        }).finally(() => setLoadingMunicipalities(false));
    };
    const addMunicipality = (data, cb) => {
        createMunicipalityApi(data).then(fetchMunicipalities).finally(cb);
    };
    const editMunicipality = (data, cb) => {
        updateMunicipalityApi(data.id, data).then(fetchMunicipalities).finally(cb);
    };
    const deleteMunicipality = (id) => {
        deleteMunicipalityApi(id).then(fetchMunicipalities);
    };

    // Comarcas CRUD
    const fetchComarcas = () => {
        setLoadingComarcas(true);
        listComarcaApi().then(resp => {
            setComarcas(resp.data.data || []);
        }).finally(() => setLoadingComarcas(false));
    };
    const addComarca = (data, cb) => {
        createComarcaApi(data).then(fetchComarcas).finally(cb);
    };
    const editComarca = (data, cb) => {
        updateComarcaApi(data.id, data).then(fetchComarcas).finally(cb);
    };
    const deleteComarca = (id) => {
        deleteComarcaApi(id).then(fetchComarcas);
    };

    // Countries CRUD
    const fetchCountries = () => {
        setLoadingCountries(true);
        listCountryApi().then(resp => {
            setCountries(resp.data.data || []);
        }).finally(() => setLoadingCountries(false));
    };
    const addCountry = (data, cb) => {
        createCountryApi(data).then(fetchCountries).finally(cb);
    };
    const editCountry = (data, cb) => {
        updateCountryApi(data.id, data).then(fetchCountries).finally(cb);
    };
    const deleteCountry = (id) => {
        deleteCountryApi(id).then(fetchCountries);
    };

    // Campos para regiones
    const fieldsTableRegion = [
        { name: "name", label: "Nombre" },
        { name: "countryName", label: "País" }
    ];
    const fieldsFormRegion = [
        { name: "name", label: "Nombre" },
        { name: "idCountry", label: "País" }
    ];

    // Campos para provincias
    const fieldsTableProvince = [
        { name: "name", label: "Nombre" },
        { name: "countryName", label: "País" },
        { name: "regionName", label: "Comunidad" }
    ];
    const fieldsFormProvince = [
        { name: "name", label: "Nombre" },
        { name: "idCountry", label: "País" },
        { name: "idRegion", label: "Comunidad" }
    ];

    // Campos para municipios
    const fieldsTableMunicipio = [
        { name: "name", label: "Nombre" },
        { name: "countryName", label: "País" },
        { name: "comarcaName", label: "Comarca" },
        { name: "regionName", label: "Comunidad" },
        { name: "provinceName", label: "Provincia" }
    ];
    const fieldsFormMunicipio = [
        { name: "name", label: "Nombre" },
        { name: "idCountry", label: "País" },
        { name: "idRegion", label: "Comunidad" },
        { name: "idProvince", label: "Provincia" },
        { name: "idComarca", label: "Comarca" },
    ];

    // Campos para comarcas
    const fieldsTableComarca = [
        { name: "name", label: "Nombre" },
        { name: "countryName", label: "País" },
        { name: "regionName", label: "Comunidad" },
        { name: "provinceName", label: "Provincia" }
    ];
    const fieldsFormComarca = [
        { name: "name", label: "Nombre" },
        { name: "idCountry", label: "País" },
        { name: "idRegion", label: "Comunidad" },
        { name: "idProvince", label: "Provincia" }
    ];

    // Campos para países
    const fieldsTableCountry = [
        { name: "name", label: "Nombre" }
        // isActive is handled as a separate column in CrudTable
    ];
    const fieldsFormCountry = [
        { name: "name", label: "Nombre" }
        // isActive is handled by CrudForm as a Switch
    ];

    return (
        <Card>
            <Box>
                <Box sx={{ mb: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Select
                        size="small"
                        value={selectedType}
                        onChange={handleSelectChange}
                        fullWidth
                        sx={{ maxWidth: 400 }}
                    >
                        <MenuItem value="paises">Países</MenuItem>
                        <MenuItem value="regiones">Comunidades</MenuItem>
                        <MenuItem value="provincias">Provincias</MenuItem>
                        <MenuItem value="comarcas">Comarcas</MenuItem>
                        <MenuItem value="municipios">Población</MenuItem>
                    </Select>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            if (selectedType === "paises") window.handleOpenCountry();
                            if (selectedType === "regiones") window.handleOpenRegion();
                            if (selectedType === "provincias") window.handleOpenProvince();
                            if (selectedType === "comarcas") window.handleOpenComarca();
                            if (selectedType === "municipios") window.handleOpenMunicipality();
                        }}
                        sx={{ whiteSpace: "nowrap", ml: 2, width: 200 }}
                    >
                        Añadir
                    </Button>
                </Box>
                {selectedType === "paises" && (
                    <CrudSection
                        items={countries}
                        onAdd={addCountry}
                        onEdit={editCountry}
                        onDelete={deleteCountry}
                        loading={loadingCountries}
                        fieldsTable={fieldsTableCountry}
                        fieldsForm={fieldsFormCountry}
                        refCallback={fn => { window.handleOpenCountry = fn; }}
                        type="país"
                    />
                )}
                {selectedType === "regiones" && (
                    <CrudSection
                        items={regions}
                        onAdd={addRegion}
                        onEdit={editRegion}
                        onDelete={deleteRegion}
                        loading={loadingRegions}
                        fieldsTable={fieldsTableRegion}
                        fieldsForm={fieldsFormRegion}
                        countryOptions={countries}
                        refCallback={fn => { window.handleOpenRegion = fn; }}
                        type="comunidad"
                    />
                )}
                {selectedType === "provincias" && (
                    <CrudSection
                        items={provinces}
                        onAdd={addProvince}
                        onEdit={editProvince}
                        onDelete={deleteProvince}
                        loading={loadingProvinces}
                        fieldsTable={fieldsTableProvince}
                        fieldsForm={fieldsFormProvince}
                        regionOptions={regions}
                        countryOptions={countries}
                        refCallback={fn => { window.handleOpenProvince = fn; }}
                        type="provincia"
                    />
                )}
                {selectedType === "comarcas" && (
                    <CrudSection
                        items={comarcas}
                        onAdd={addComarca}
                        onEdit={editComarca}
                        onDelete={deleteComarca}
                        loading={loadingComarcas}
                        fieldsTable={fieldsTableComarca}
                        fieldsForm={fieldsFormComarca}
                        regionOptions={regions}
                        provinceOptions={provinces}
                        countryOptions={countries}
                        refCallback={fn => { window.handleOpenComarca = fn; }}
                        type="comarca"
                    />
                )}
                {selectedType === "municipios" && (
                    <CrudSection
                        items={municipalities}
                        onAdd={addMunicipality}
                        onEdit={editMunicipality}
                        onDelete={deleteMunicipality}
                        loading={loadingMunicipalities}
                        fieldsTable={fieldsTableMunicipio}
                        fieldsForm={fieldsFormMunicipio}
                        provinceOptions={provinces}
                        comarcaOptions={comarcas}
                        countryOptions={countries}
                        regionOptions={regions}
                        refCallback={fn => { window.handleOpenMunicipality = fn; }}
                        type="población"
                    />
                )}
            </Box>
        </Card>
    );
}
